export enum THEME {
  WHITE = 'white',
  DARK = 'dark',
}
